<div class="currency-table-cell">
  <app-currency-view [currencyViewData]="data"></app-currency-view>
</div>
